import React from 'react';
import Grid from '@mui/material/Grid2';

import { CreatureLimitEnhancement } from "@dndModels";

import CreatureLimitInput from '@dndComponents/limitations/CreatureLimitInput';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  value: CreatureLimitEnhancement;
  disabled: boolean;
  onChange: () => void;
}

export default function CreatureLimitEnhancementInput({
  value,
  disabled,
  onChange
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>
        <EnhancementModeBox
          name="Creature Limit Mode"
          modes={["Leave","Replace"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as CreatureLimitEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={12}>
        <CreatureLimitInput
          obj={value.value}
          disabled={disabled || value.mode === "Leave"}
          onChange={(changed) => {
            value.value = changed.clone();
            onChange();
          }}
        />
      </Grid>
    </Grid>
  );
}
